/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import {
  MAIN_ICON_COLORS,
  VerificationActionButton,
  UpgradeLevelButton,
  PersonalInfoUserSettingIcon,
} from 'assets/components';
import { Tooltip } from 'react-tooltip';
import { useCardStatus, useUserPersonalInfo } from '../../../utilities/sharedHooks/user';
import {
  currencies,
  exchange,
  TIER_LEVEL,
  TIER_LEVEL_TITLE,
  VerificationState,
} from '../../../utilities/constants';
import Icon from '../../../components/Icon';
import { ICONS } from '../../../components/Icon/constants';
import { formatNumber, formatNumberWithComma } from '../../../utilities/formatHelpers';
import { USER_LIFETIME_TRANSACTIONS } from '../../../utilities/sharedMutations';
import useRiskTierSettings from '../../../utilities/sharedHooks/useRiskTierSettings';
import { MODAL_SCREENS } from '../constants';
import ModalLayout from '../../shared/ModalLayout';
import InfoPopup from '../../shared/Modals/InfoPopup';
import { useSetting } from '../../../utilities/sharedHooks/settings';
import { upgradeAccountScreens } from './UpgradeAccount/constant';
import { GET_CARD_SPENDING_LIMITS } from '../queries';
import { USER_GET_OAUTH_INFO } from '../../Oauth/queries';
import { Typography } from '../../../components';
import OauthRevokeModal from '../../Oauth/OauthRevokeModal';

const Account = () => {
  const { t: translate } = useTranslation();

  const { verificationState, riskTier, id } = useUserPersonalInfo();

  const [supportEmailAddress] = useSetting('server_configurations', 'support_email_address');

  const { state } = useLocation();
  const history = useHistory();

  const { data: oauth2Info } = useQuery(USER_GET_OAUTH_INFO);

  const [oauthRevokeModalOpen, setOauthRevokeModalOpen] = useState(false);

  const { data: lifeTimeTransactionDetails, refetch: getLifeTimeTransactionsDetails } = useQuery(
    [USER_LIFETIME_TRANSACTIONS, id],
    {
      enabled: false,
    }
  );

  const [windowSize, setWindowSize] = useState([0, 0]);

  const { riskAssessment } = useRiskTierSettings();

  const { data: cardStatus } = useCardStatus();

  const { data: cardSpendingLimits, refetch: refetchCardSpendingLimits } = useQuery(
    [GET_CARD_SPENDING_LIMITS, cardStatus?.cardID],
    {
      enabled: false,
    }
  );

  useEffect(() => {
    if (cardStatus && cardStatus?.cardID) {
      refetchCardSpendingLimits();
    }
  }, [cardStatus]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentScreen, setCurrentScreen] = useState('');

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const screenWidth = windowSize[0];
  const allowPopupModalActionForSmallScreenSizes = useMemo(() => screenWidth < 790, [screenWidth]);

  const showScreen = (screen) => {
    setCurrentScreen(screen);
    setIsModalVisible(true);
  };

  const infoPopupOptions = {
    content: () => (
      <p className="text-white text-f6 mt-2">
        {translate('settings_account_transaction_max_amount_note')}
      </p>
    ),
    withBack: false,
    isButtonInFooter: false,
    isScrollable: false,
  };

  const infoPopupDailyOptions = {
    content: () => (
      <>
        <p>{translate('current_daily_card_spend_1')}</p>
        <p className="mt-4">{translate('current_daily_card_spend_2')}</p>
      </>
    ),
    withBack: false,
    isButtonInFooter: false,
    isScrollable: false,
  };

  const infoPopupWeeklyOptions = {
    content: () => (
      <>
        <p>{translate('current_weekly_card_spend_1')}</p>
        <p className="mt-4">{translate('current_weekly_card_spend_2')}</p>
      </>
    ),
    withBack: false,
    isButtonInFooter: false,
    isScrollable: false,
  };

  useEffect(() => {
    if (id) {
      getLifeTimeTransactionsDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (state && state?.upgradeAccount) {
      history.push('upgrade-account', {
        initScreen: upgradeAccountScreens.START_UPGRADE,
        openedFromCardOrder: true,
      });
      window.history.replaceState({}, '');
    }
  }, [state]);

  const filteredState = useMemo(
    () =>
      verificationState === VerificationState.CHECKED ||
      verificationState === VerificationState.EDD_SUBMITED ||
      verificationState === VerificationState.EDD_REQUIRED
        ? VerificationState.PENDING
        : verificationState,
    [verificationState]
  );

  const userStatus = Object.keys(VerificationState).find(
    (key) => VerificationState[key] === filteredState
  );

  const verificationButtonText = useMemo(() => {
    if (filteredState === VerificationState.DENIED) {
      return translate('account_verification_button_retry');
    }
    if (filteredState === VerificationState.UNVERIFIED) {
      return translate('account_verification_button_start');
    }

    return '';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredState]);

  const tierLevel = (key) => {
    switch (key) {
      case TIER_LEVEL.ZERO:
      case TIER_LEVEL.FOUR:
        return TIER_LEVEL_TITLE.BASIC;
      case TIER_LEVEL.TWO:
      case TIER_LEVEL.FIVE:
        return TIER_LEVEL_TITLE.ADVANCED;
      case TIER_LEVEL.THREE:
      case TIER_LEVEL.SIX:
        return TIER_LEVEL_TITLE.PRO;
      default:
        return TIER_LEVEL_TITLE.BASIC;
    }
  };

  const iconLevelColors = {
    [TIER_LEVEL_TITLE.BASIC]: 'bg-info',
    [TIER_LEVEL_TITLE.PRO]: 'bg-info-shade',
    [TIER_LEVEL_TITLE.ADVANCED]: 'bg-warning-khaki',
  };

  const accountStatus = useMemo(() => {
    if (riskTier && riskTier.key === TIER_LEVEL.NINE) {
      return {
        label: translate('pending_label'),
        bgColor: '',
        textColor: '',
        withIcon: false,
      };
    }
    if (riskTier && riskTier.key === TIER_LEVEL.TEN) {
      return {
        label: translate('rejected_label'),
        bgColor: 'bg-danger-light',
        textColor: 'text-danger',
        withIcon: false,
      };
    }
    return {
      label: translate('active_label'),
      bgColor: 'bg-success-light',
      textColor: 'text-success',
      withIcon: true,
    };
  }, [translate, riskTier]);

  const verificationActionButton = (
    <VerificationActionButton
      disabled={
        filteredState !== VerificationState.UNVERIFIED && filteredState !== VerificationState.DENIED
      }
      onClick={() => history.push(`/kyc`, { switch: true })}
      label={verificationButtonText}
    />
  );

  const renderVerificationStatusSection = () => (
    <div className="d-flex flex-column bg-lighter rounded-extra p-4 mt-4">
      <p className="text-f5 text-dark text-bold letter-spacing-2">
        {translate('verification_status')}
      </p>
      <div className="d-flex flex-row justify-content-start align-items-center mt-3">
        <PersonalInfoUserSettingIcon />
        <div className="d-flex flex-column">
          <div className="d-flex flex-row align-items-center">
            <p className="text-dark text-f5 letter-spacing-2">
              {translate('settings_account_your_account_label')}
            </p>
            <div
              style={{ borderRadius: '4px' }}
              className={`ms-2 px-2
              ${filteredState === VerificationState.PENDING ? 'bg-light' : ''}
              ${filteredState === VerificationState.UNVERIFIED ? 'bg-warning-light' : ''}
              ${filteredState === VerificationState.DENIED ? 'bg-danger-light' : ''}${
                filteredState === VerificationState.VERIFIED ? 'bg-success-light' : ''
              }
              `}>
              <p
                style={{ lineHeight: '1.7' }}
                className={`text-uppercase text-f6 letter-spacing-3
                    ${process.env.REACT_APP_FLAVOR !== '1inch' ? 'alpha-font' : ''}
                    ${filteredState === VerificationState.DENIED ? 'text-danger' : ''}
                    ${filteredState === VerificationState.UNVERIFIED ? 'text-warning' : ''}${
                  filteredState === VerificationState.VERIFIED ? 'text-success' : ''
                }
                `}>{`${
                filteredState !== VerificationState.DENIED
                  ? translate(userStatus?.toLocaleLowerCase())
                  : translate('account_verification_status_declined')
              }${filteredState === VerificationState.PENDING ? '...' : ''}`}</p>
            </div>
          </div>
          <p className="text-f6 text-shadow letter-spacing-3">
            {translate(`account_verification_subtext_${userStatus?.toLocaleLowerCase()}`)}
          </p>
        </div>
        <div className="ms-auto d-lg-block d-md-block d-sm-none d-none">
          {verificationActionButton}
        </div>
      </div>
      {oauth2Info?.status?.connected && (
        <div className="d-flex flex-row justify-content-start align-items-center mt-3">
          <div
            className="rounded-max bg-settings-icon me-3"
            style={{ height: '2.3rem', width: '2.3rem', paddingTop: '4px' }}>
            <div className="w-100" style={{ height: '16px', width: '16px' }}>
              <Icon icon={ICONS.CONNECT} color={MAIN_ICON_COLORS.INFO} />
            </div>
          </div>
          <div className="d-flex flex-column">
            <Typography as="p" variant="base">
              {translate('setting_account_connected_apps')}
            </Typography>
            <div className="d-flex gap-2 align-content-center">
              <Typography as="p" variant="base" className="text-shadow">
                {translate('setting_account_connected_apps_sub')}
              </Typography>
              <button
                type="submit"
                className="btn text-btn-item text-danger p-0"
                onClick={() => {
                  setOauthRevokeModalOpen(true);
                }}>
                {translate('setting_account_connected_apps_action')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const renderCurrentAccountLevel = () => (
    <div className="d-flex flex-column bg-lighter rounded-extra p-4 mt-4">
      <p className="text-f5 text-dark text-bold letter-spacing-2">{translate('account_level')}</p>
      <div className="d-flex flex-row justify-content-start align-items-center mt-4">
        <div
          className={`rounded-max me-3 ${iconLevelColors[tierLevel(riskTier.key)]}`}
          style={{ height: '2.3rem', width: '2.3rem', paddingTop: '3px' }}>
          <div className="w-100" style={{ height: '16px', width: '16px' }}>
            <Icon icon={ICONS.STAR} color={MAIN_ICON_COLORS.GRAY_LIGHT} />
          </div>
        </div>
        <div className="d-flex flex-column">
          <p className="text-bold text-dark" style={{ letterSpacing: '0.66px', fontSize: '22px' }}>
            {tierLevel(riskTier.key)}
          </p>
          <div className="d-flex flex-row align-items-center mt-1">
            {accountStatus.withIcon && (
              <div className="d-flex h-100 me-1" style={{ height: '10px', width: '10px' }}>
                <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.SUCCESS} />
              </div>
            )}
            <p className={`text-f6 text-bold letter-spacing ${accountStatus.textColor}`}>
              {accountStatus.label}
            </p>
          </div>
        </div>
      </div>

      <div className="d-flex flex-column mt-4">
        <div className="d-flex flex-lg-row flex-md-row flex-sm-row flex-column">
          <div className="col-sm-6 col-12">
            <p className="letter-spacing-2">
              {riskTier?.receive_crypto
                ? translate('receive_crypto_unlimited')
                : translate('receive_crypto_disabled')}
            </p>
            <p className="text-f6 text-shadow letter-spacing-3">
              {translate('receive_digital_currency_label')}
            </p>
          </div>
          <div className="col-sm-6 col-12 mt-sm-0 mt-3">
            <p className="letter-spacing-2">
              {riskTier?.max_send_per_txn >= 0
                ? `${formatNumberWithComma(riskTier?.max_send_per_txn)} ${translate(
                    'usd_transaction'
                  )}`
                : translate('unlimited_trx')}
            </p>
            <p className="text-f6 text-shadow letter-spacing-3">
              {translate('send_digital_currency_label')}
            </p>
          </div>
        </div>
        <div className="d-flex flex-sm-row flex-column mt-3">
          <div className="col-sm-6 col-12">
            <p className="letter-spacing-2">
              {riskTier?.max_payment_gateway >= 0
                ? `${formatNumberWithComma(riskTier?.max_payment_gateway)} ${translate(
                    'usd_transaction'
                  )}`
                : translate('unlimited_trx')}
            </p>
            <p className="text-f6 text-shadow letter-spacing-3">
              {translate('fiat_deposit_label')}
            </p>
          </div>
          <div className="col-sm-6 col-12 mt-sm-0 mt-3">
            <p className="letter-spacing-2">
              {riskTier?.max_total_transaction >= 0
                ? `${formatNumberWithComma(
                    formatNumber(
                      lifeTimeTransactionDetails?.total_outgoing_net_value *
                        currencies.USD.conversion,
                      currencies.USD.decimal
                    )
                  )} ${currencies.USD.fullName} / ${formatNumberWithComma(
                    riskTier?.max_total_transaction
                  )} ${currencies.USD.fullName}`
                : translate('unlimited_trx')}
            </p>
            <div className="d-flex flex-row align-items-center position-relative">
              <p className="text-f6 text-shadow me-1 letter-spacing-3">
                {translate('accumulative_turnover_label')}
              </p>
              <div
                data-tooltip-id="max-amount-note"
                className="cursor-pointer text-hover"
                onClick={
                  isMobile || allowPopupModalActionForSmallScreenSizes
                    ? () => showScreen(MODAL_SCREENS.INFO_POPUP)
                    : () => {}
                }
                role="presentation">
                <i className="icon icon-info-icon text-f5 text-shadow" />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-sm-row flex-column mt-3">
          <div className="col-sm-6 col-12">
            <p className="letter-spacing-2">
              {riskTier?.buffer_max_per_day > 0
                ? `${formatNumberWithComma(
                    formatNumber(
                      cardSpendingLimits?.spend_from_day_start * currencies.USD.conversion,
                      currencies.USD.decimal
                    )
                  )} USD / ${formatNumberWithComma(riskTier?.buffer_max_per_day)} USD`
                : translate('unlimited_trx')}
            </p>
            <div className="d-flex flex-row align-items-center position-relative">
              <p className="text-f6 text-shadow me-1 letter-spacing-3">
                {translate('daily_card_limit')}
              </p>
              <div
                data-tooltip-id="current-daily-spend"
                className="cursor-pointer text-hover"
                onClick={
                  isMobile || allowPopupModalActionForSmallScreenSizes
                    ? () => showScreen(MODAL_SCREENS.INFO_POPUP_DAILY)
                    : () => {}
                }
                role="presentation">
                <i className="icon icon-info-icon text-f5 text-shadow" />
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-12 mt-sm-0 mt-3">
            <p className="letter-spacing-2">
              {riskTier?.buffer_max_per_week > 0
                ? `${formatNumberWithComma(
                    formatNumber(
                      cardSpendingLimits?.spend_from_week_start * currencies.USD.conversion,
                      currencies.USD.decimal
                    )
                  )} USD / ${formatNumberWithComma(riskTier?.buffer_max_per_week)} USD`
                : translate('unlimited_trx')}
            </p>
            <div className="d-flex flex-row align-items-center position-relative">
              <p className="text-f6 text-shadow me-1 letter-spacing-3">
                {translate('weekly_card_limit')}
              </p>
              <div
                data-tooltip-id="current-weekly-spend"
                className="cursor-pointer text-hover"
                onClick={
                  isMobile || allowPopupModalActionForSmallScreenSizes
                    ? () => showScreen(MODAL_SCREENS.INFO_POPUP_WEEKLY)
                    : () => {}
                }
                role="presentation">
                <i className="icon icon-info-icon text-f5 text-shadow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderNextAccountLevel = (nextTier, isTier0) => {
    if (isTier0) return <></>;

    if (!nextTier)
      return (
        <div className="text-shadow mt-4 letter-spacing-2" style={{ fontSize: '14px' }}>
          <Trans
            i18nKey="tier_next_level_unupgradable_text"
            values={{
              support_email: supportEmailAddress,
            }}
            components={[
              <a
                key="support-email"
                className="text-decoration-none"
                href={`mailto:${supportEmailAddress}`}
                rel="noreferrer"
              />,
            ]}
          />
        </div>
      );

    return (
      <div className="d-flex flex-column bg-lighter rounded-extra p-4 mt-4">
        <div className="d-flex flex-row align-items-center justify-content-between">
          <p className="text-f5 text-dark text-bold letter-spacing-2">
            {translate('tier_next_level_label')}
          </p>
          <UpgradeLevelButton
            label={translate('upgrade_to_advanced_btn_label', {
              level:
                tierLevel(riskAssessment?.userNextTier?.key) === TIER_LEVEL_TITLE.PRO
                  ? tierLevel(riskAssessment?.userNextTier?.key).toUpperCase()
                  : tierLevel(riskAssessment?.userNextTier?.key),
            })}
            disabled={riskAssessment?.userNextTier?.hasActiveChangeTierRequest}
            onClick={() =>
              history.push('upgrade-account', {
                initScreen: upgradeAccountScreens.UPGRADE_LEVEL,
              })
            }
          />
        </div>
        <div className="d-flex flex-row justify-content-start align-items-center mt-4">
          <div
            className={`rounded-max me-3 ${
              iconLevelColors[tierLevel(riskAssessment?.userNextTier?.key)]
            }`}
            style={{ height: '2.3rem', width: '2.3rem', paddingTop: '3px' }}>
            <div className="w-100" style={{ height: '16px', width: '16px' }}>
              <Icon icon={ICONS.STAR} color={MAIN_ICON_COLORS.GRAY_LIGHT} />
            </div>
          </div>
          <div className="d-flex flex-column">
            <p
              className="text-bold text-dark"
              style={{ letterSpacing: '0.66px', fontSize: '22px' }}>
              {tierLevel(riskAssessment?.userNextTier?.key)}
            </p>
            {riskAssessment?.userNextTier?.hasActiveChangeTierRequest && (
              <>
                <div className="d-flex flex-row align-items-center mt-1">
                  {accountStatus.withIcon && (
                    <div className="d-flex h-100 me-1" style={{ height: '12px', width: '12px' }}>
                      <Icon icon={ICONS.LOADING} color={MAIN_ICON_COLORS.DANGER} />
                    </div>
                  )}
                  <p className="text-f6 text-bold text-danger">{translate('requested_label')}</p>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="d-flex flex-column mt-4">
          <div className="d-flex flex-sm-row flex-column">
            <div className="col-sm-6 col-12">
              <p className="letter-spacing-2">{translate('receive_crypto_unlimited')}</p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('receive_digital_currency_label')}
              </p>
            </div>
            <div className="col-sm-6 col-12 mt-sm-0 mt-3">
              <p className="letter-spacing-2">
                {riskAssessment?.userNextTier?.max_send_per_txn >= 0
                  ? `${formatNumberWithComma(
                      formatNumber(
                        riskAssessment?.userNextTier?.max_send_per_txn,
                        exchange.FIAT_VALUE
                      )
                    )} ${translate('usd_transaction')}`
                  : translate('unlimited_trx')}
              </p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('send_digital_currency_label')}
              </p>
            </div>
          </div>
          <div className="d-flex flex-sm-row flex-column mt-3">
            <div className="col-sm-6 col-12">
              <p className="letter-spacing-2">
                {riskAssessment?.userNextTier.max_payment_gateway >= 0
                  ? `${formatNumberWithComma(
                      riskAssessment?.userNextTier.max_payment_gateway
                    )} ${translate('usd_transaction')}`
                  : translate('unlimited_trx')}
              </p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('fiat_deposit_label')}
              </p>
            </div>
            <div className="col-sm-6 col-12 mt-sm-0 mt-3 position-relative">
              <p className="letter-spacing-2">
                {riskAssessment?.userNextTier.max_total_transaction >= 0
                  ? `${formatNumberWithComma(riskAssessment?.userNextTier.max_total_transaction)} ${
                      currencies.USD.fullName
                    }`
                  : translate('unlimited_trx')}
              </p>
              <div className="d-flex flex-row align-items-center position-relative">
                <p className="text-f6 text-shadow me-1 letter-spacing-3">
                  {translate('accumulative_turnover_label')}
                </p>
                <div
                  data-tooltip-id="max-amount-note"
                  className="cursor-pointer text-hover"
                  onClick={() => showScreen(MODAL_SCREENS.INFO_POPUP)}
                  role="presentation">
                  <i className="icon icon-info-icon text-f5 text-shadow" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column mt-4">
          <div className="d-flex flex-sm-row flex-column">
            <div className="col-sm-6 col-12">
              <p className="letter-spacing-2">{`${
                riskAssessment?.userNextTier?.buffer_max_per_day > 0
                  ? `${formatNumberWithComma(
                      riskAssessment?.userNextTier?.buffer_max_per_day
                    )} ${translate('usd_per_day')}`
                  : translate('unlimited_trx')
              }`}</p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('daily_card_limit')}
              </p>
            </div>
            <div className="col-sm-6 col-12 mt-sm-0 mt-3">
              <p className="letter-spacing-2">{`${
                riskAssessment?.userNextTier?.buffer_max_per_week > 0
                  ? `${formatNumberWithComma(
                      riskAssessment?.userNextTier?.buffer_max_per_week
                    )} ${translate('usd_per_week')}`
                  : translate('unlimited_trx')
              }`}</p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('weekly_card_limit')}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="mt-3 d-flex flex-column w-100 h-lg-100 h-md-100 h-sm-100">
        <p className="text-f3 text-dark text-bold pe-5 letter-spacing-1 line-height-sm-1 line-height-2">
          {translate('settings_account_tab_label')}
        </p>
        <p className="mt-3 text-f6 text-shadow letter-spacing-3">
          {translate('settings_account_tab_desc')}
        </p>
        <div className="d-flex flex-column h-100">
          {renderVerificationStatusSection()}
          {riskAssessment.settings &&
            riskAssessment.userRisk.key !== TIER_LEVEL.ZERO &&
            renderCurrentAccountLevel()}
          {riskAssessment.settings &&
            renderNextAccountLevel(
              riskAssessment.userNextTier,
              riskAssessment.userRisk.key === TIER_LEVEL.ZERO
            )}
          {isMobile && riskAssessment?.settings && riskAssessment.userNextTier && (
            <div className="d-flex flex-column justify-content-end align-items-center mt-3">
              <button
                type="button"
                className="btn py-3 btn-primary w-100"
                disabled={riskAssessment?.userNextTier?.hasActiveChangeTierRequest}
                onClick={() =>
                  history.push('upgrade-account', {
                    initScreen: upgradeAccountScreens.UPGRADE_LEVEL,
                  })
                }>
                {translate('upgrade_to_advanced_btn_label', {
                  level:
                    tierLevel(riskAssessment?.userNextTier?.key) === TIER_LEVEL_TITLE.PRO
                      ? tierLevel(riskAssessment?.userNextTier?.key).toUpperCase()
                      : tierLevel(riskAssessment?.userNextTier?.key),
                })}
              </button>
            </div>
          )}
          {isMobile && verificationActionButton}
        </div>
      </div>
      <ModalLayout
        onHide={() => setIsModalVisible(false)}
        withButtons={false}
        isVisible={isModalVisible}
        currentScreen={currentScreen}>
        <InfoPopup keyName={MODAL_SCREENS.INFO_POPUP} options={infoPopupOptions} />
        <InfoPopup keyName={MODAL_SCREENS.INFO_POPUP_DAILY} options={infoPopupDailyOptions} />
        <InfoPopup keyName={MODAL_SCREENS.INFO_POPUP_WEEKLY} options={infoPopupWeeklyOptions} />
      </ModalLayout>
      <ModalLayout
        onHide={() => setOauthRevokeModalOpen(false)}
        isVisible={oauthRevokeModalOpen}
        currentScreen="revoke_connect">
        <OauthRevokeModal keyName="revoke_connect" setOpen={setOauthRevokeModalOpen} />
      </ModalLayout>
      <Tooltip
        id="current-daily-spend"
        place="right"
        variant="dark"
        opacity={1}
        className="p-4 rounded border-1 custom-tooltip">
        <p>{translate('current_daily_card_spend_1')}</p>
        <p className="mt-4">{translate('current_daily_card_spend_2')}</p>
      </Tooltip>
      <Tooltip
        id="current-weekly-spend"
        place="right"
        variant="dark"
        opacity={1}
        className="p-4 rounded border-1 custom-tooltip">
        <p>{translate('current_weekly_card_spend_1')}</p>
        <p className="mt-4">{translate('current_weekly_card_spend_2')}</p>
      </Tooltip>
      <Tooltip
        id="max-amount-note"
        place="right"
        variant="dark"
        opacity={1}
        className="p-4 rounded border-1 custom-tooltip">
        <p>{translate('settings_account_transaction_max_amount_note')}</p>
      </Tooltip>
    </>
  );
};

export default Account;
